module.exports = __webpack_public_path__ + "img/service-nongmaozonghe1.202cae2f.svg";